import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTemperamentAssessment, UpdateUser } from "../api/api";
import "../TemperamentQuestion/TemperamentQuestion.css";
import bgImage from "../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const TemperamentQuestion = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [questions, setQuestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const questionsPerPage = 1;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTemperamentAssessment = async () => {
      try {
        const response = await getTemperamentAssessment();
        console.log(
          "getTemperamentAssessment qeustion:",
          JSON.stringify(response)
        );
        if (response?.success) {
          const formattedQuestions = response.data.map((item) => ({
            id: item.id,
            question: item.question,
            options: item.answers.map((answer, idx) => ({
              index: answer.index !== undefined ? answer.index : idx,
              answer: answer.answer,
              category_id: answer.category_id || answer.category,
            })),
          }));

          console.log("Formatted Questions:", formattedQuestions);
          setQuestions(formattedQuestions);
        } else {
          alert("Failed to fetch Temperament Assessment Questions");
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemperamentAssessment();
  }, []);

  const handleOptionPress = (questionId, answer) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: prev[questionId] === answer ? null : answer,
    }));
  };

  const handleSubmit = async () => {
    const unansweredQuestions = questions.filter((q) => !selectedAnswers[q.id]);

    if (unansweredQuestions.length > 0) {
      alert("Please answer all questions");
    } else {
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const userId = userData?.id || userData?._id;
        const formattedAnswers = Object.entries(selectedAnswers).map(
          ([questionId, answer]) => {
            const question = questions.find((q) => q.id === questionId);
            const selectedOption = question?.options.find(
              (opt) => opt.answer === answer
            );

            return {
              question_id: question?.id,
              option_index: selectedOption?.index,
              category_id:
                selectedOption?.category_id || selectedOption?.category,
            };
          }
        );

        const values = {
          user_id: userId,
          userAnswersTemperament: formattedAnswers,
          profile_completion_status: "userAnswersValue",
        };

        console.log("Form values:", values);
        const response = await UpdateUser(values);
        console.log("API Response:", response);

        if (response?.success) {
          navigate("/ValuesAssessment");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.message,
          });
        }
      } catch (error) {
        console.error("Error submitting assessment:", error);
      }
    }
  };

  const startIndex = currentPage * questionsPerPage;
  const currentQuestions = (questions || []).slice(
    startIndex,
    startIndex + questionsPerPage
  );

  const isNextEnabled =
    currentQuestions?.length > 0 && !!selectedAnswers[currentQuestions[0]?.id];

  if (isLoading) {
    return <div>Loading questions...</div>;
  }
  const unansweredQuestions = questions?.filter((q) => !selectedAnswers[q.id]);

  return (
    <div
      className="TemperamentQuestioncontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="TemperamentSmallContainer">
          <h1 className="Temperamenttitle">Temperament Assessment</h1>
          {currentQuestions?.map((question, index) => (
            <div key={question?.id} className="Temperamentquestion-container">
              <p className="Temperamentquestion-text">{`Q${startIndex + index + 1
                }: ${question?.question}`}</p>
              {(question?.options || []).map((option, idx) => (
                <div
                  key={option?.index || idx}
                  className={`Temperamentoption-container ${selectedAnswers[question?.id] === option?.answer
                    ? "selected-option"
                    : ""
                    }`}
                  onClick={() => handleOptionPress(question?.id, option?.answer)}
                >
                  <div
                    className={`Temperamentradio-button ${selectedAnswers[question?.id] === option?.answer
                      ? "selected-radio-button"
                      : ""
                      }`}
                  />
                  <p className="Temperamentoption-text">{option?.answer}</p>
                </div>
              ))}
            </div>
          ))}

          <div className="Temperamentnavigation-container">
            {currentPage > 0 && (
              <button
                className="Temperamentprevious-button"
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                Previous
              </button>
            )}

            {currentPage < Math.ceil(questions.length / questionsPerPage) - 1 ? (
              <button
                className={`Temperamentnavigation-button ${!isNextEnabled ? "disabled-button" : ""
                  }`}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                disabled={!isNextEnabled}
              >
                Next
              </button>
            ) : (
              <button
                className="Temperamentsubmit-button"
                onClick={handleSubmit}
                disabled={unansweredQuestions?.length > 0}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemperamentQuestion;
